import { FetchConfig } from '../../redux/apiTypes';

type ChainUnreadMessagesDto = {
  chain_id: string;
  count_of_orders_with_unread_msgs: number;
  count_of_marketing_unread_msgs: number;
}

async function requestGetUnreadMessages(fetchConfig: FetchConfig):Promise<ChainUnreadMessagesDto[]> {
  const { apiRoot, xChain, xVersion } = fetchConfig;
  const url = `${apiRoot}/user/retail_chains/unread_messages/`;

  try {
    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'x-chain': xChain,
        'x-version': xVersion,
      },
    });

    if (!response.ok) {
      return [];
    }

    return await response.json();
  } catch {
    return [];
  }
}

export default requestGetUnreadMessages;
